import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export type PreviewLayouts = 'thumbnail' | 'post' | 'page';
@Component({
  selector: 'rma-blog-post-skeleton',
  templateUrl: './post-skeleton.component.html',
  styleUrls: ['./post-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PostSkeletonComponent {
  @Input()
  public layout: PreviewLayouts = 'thumbnail';

  @HostBinding('class')
  public get className(): string {
    return `${this.layout}-layout`;
  }
}
